import React from "react";
import Accordion from "react-bootstrap/Accordion";

const Blog = () => {
  return (
    <div className="container mb-5 mt-5">
      <h1 className="text-primary mt-5 text-center fw-bold">Some Important Questions</h1>
      <div className="container mt-5">
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <h5>What is cors ?</h5>
            </Accordion.Header>
            <Accordion.Body>
              Cross-Origin Resource Sharing (CORS) is an HTTP-header based
              mechanism that allows a server to indicate any origins (domain,
              scheme, or port) other than its own from which a browser should
              permit loading resources. CORS also relies on a mechanism by which
              browsers make a "preflight" request to the server hosting the
              cross-origin resource, in order to check that the server will
              permit the actual request. In that preflight, the browser sends
              headers that indicate the HTTP method and headers that will be
              used in the actual request.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h5>
                {" "}
                Why are you using firebase? What other options do you have to
                implement authentication? ?
              </h5>
            </Accordion.Header>
            <Accordion.Body>
              Firebase an Authentication system of Google. Hence it is one of
              the safest and easiest Authentication system. That's the reason I
              am using it. Firebase Authentication provides backend services,
              easy-to-use SDKs, and ready-made UI libraries to authenticate
              users to your app. It supports authentication using passwords,
              phone numbers, popular federated identity providers like Google,
              Facebook and Twitter, and more. Other Options of implementing
              authentication are : Auth0, MongoDB, Passport, Okta, and Firebase
              are the most popular alternatives and competitors to Firebase
              Authentication.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <h5>How does the private route work?</h5>
            </Accordion.Header>
            <Accordion.Body>
              The react private route component renders child components (
              children ) if the user is logged in. If not logged in the user is
              redirected to the /login page with the return url passed in the
              location state property.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>
              <h5>What is Node? How does Node work?</h5>
            </Accordion.Header>
            <Accordion.Body>
              Node is used as a backend service where javascript works on the
              server-side of the application. This way javascript is used on
              both frontend and backend. Node. js runs on chrome v8 engine which
              converts javascript code into machine code, it is highly scalable,
              lightweight, fast, and data-intensive.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};

export default Blog;
